import * as React from 'react';

import * as styles from './highwayList.css';

export const HighwayList = (props: React.PropsWithChildren<{}>) => {
  return <ul className={styles['highways']}>{props.children}</ul>;
};
